import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import IdleTimer from 'react-idle-timer'

class Heartbeat extends PureComponent {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    sendBeat: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.idleTimer = null
  }

  render() {
    const { sendBeat, profile } = this.props

    return (
      <div>
        {profile.id && (
          <IdleTimer
            ref={(ref) => {
              this.idleTimer = ref
            }}
            element={document}
            onActive={sendBeat}
            onAction={sendBeat}
            throttle={1000 * 60}
            timeout={1000 * 60 * 5}
          />
        )}
      </div>
    )
  }
}

export default Heartbeat
